import { NewLocationBankingData } from "./newLocationBankingData.model";
import { NewLocationInfo } from "./newLocationInfo.model";
import { NewData } from "./newData.model";

export class NewLocation{
    constructor(
        public info: NewLocationInfo = new NewLocationInfo(),
        public bankData: NewLocationBankingData = new NewLocationBankingData(),
        public data: NewData = new NewData(),
        public locationID: String = '',
      ) {}
}